function accordion() {
  document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".accordion");
  
    accordions.forEach((container) => {
      const toggleButton = container.querySelector(".accordion-toggle");
      const content = container.querySelector(".accordion-content");
  
      if (toggleButton && content) {
        toggleButton.addEventListener("click", () => {
          content.classList.toggle("hidden"); // Toggle the 'hidden' class
        });
      }
    });
  });
}
